import type { FC } from 'react';
import { Icon } from '../../../core-components/Icon';
import { DataRow, RowItem } from '../DataRow';

export type FlightTimelineEntryProps = {
  departureTime: string;
  departureTimeDayShift?: number;
  departureAirport: string;

  arrivalTime: string;
  arrivalTimeDayShift?: number;
  arrivalAirport: string;

  rowItems?: RowItem[];
};

export const FlightTimelineEntry: FC<FlightTimelineEntryProps> = ({
  departureTime,
  departureTimeDayShift,
  departureAirport,

  arrivalTime,
  arrivalTimeDayShift,
  arrivalAirport,

  rowItems,
}) => {
  return (
    <div className="flex w-full flex-row text-marine-high-emphasis">
      <div className="mr-4 flex flex-col items-center">
        <Icon name="departure" size="md" />
        <div className="flex h-full w-full justify-center">
          <div className="my-1 border-l border-secondary-marine-100 rounded-full" />
        </div>
        <Icon name="arrival" size="md" />
      </div>
      <div className="flex flex-1 flex-col gap-4">
        <div className="flex flex-row items-center justify-between">
          <div className="flex flex-row items-start gap-2">
            <span className="headline-lg">{departureTime}</span>
            {(departureTimeDayShift ?? 0) > 0 && (
              <span className="text-sm font-semibold">
                +{departureTimeDayShift}
              </span>
            )}
          </div>
          <div className="text-marine-medium-emphasis">{departureAirport}</div>
        </div>

        {rowItems && (
          <div className="flex flex-col gap-3">
            <ul>
              {rowItems?.map((item, index) => (
                <DataRow key={index} {...item} />
              ))}
            </ul>
          </div>
        )}

        <div className="flex flex-row items-center justify-between">
          <div className="flex flex-row items-start gap-2">
            <span className="headline-lg">{arrivalTime}</span>
            {(arrivalTimeDayShift ?? 0) > 0 && (
              <span className="text-sm font-semibold">
                +{arrivalTimeDayShift}
              </span>
            )}
          </div>
          <div className="text-marine-medium-emphasis">{arrivalAirport}</div>
        </div>
      </div>
    </div>
  );
};
